import React, { Component } from 'react';
import './Component.css';
import Sankey from './Sankey/Sankey.js';
import Treemap from './Treemap/Treemap.jsx';
import ReadMore from './ReadMore/ReadMore.jsx';
import { getText } from './AllTexts.jsx';

class ScaleMetropolitan extends Component {
  render() {
    let renderWidth = this.props.width + 200;
    let text, sankeyText;
    if (this.props.city === 'vancouver') {
      text = getText('scale-metropolitan-intro-vancouver');
      sankeyText = getText('scale-metropolitan-sankey-vancouver');
    } else if (this.props.city === 'toronto') {
      text = getText('scale-metropolitan-intro-toronto');
      sankeyText = getText('scale-metropolitan-sankey-toronto');
    }

    return (
      <div className="Scale-Metropolitan Component" id="metropolitan">
        <div className="text">
          <p className="title">{getText('scale-metropolitan-title')}</p>
          {text}
        </div>
        <div className="graphic">
          <Treemap
            width={this.props.width}
            height={this.props.height}
            year={this.props.params.treePermanent.year}
            category={this.props.params.treePermanent.category}
            city={this.props.city}
            update={this.props.update.treePermanent}
            type='permanent' />
        </div>
        <div className="graphic">
          <Treemap
            width={this.props.width}
            height={this.props.height}
            year={this.props.params.treeTemporary.year}
            category={this.props.params.treeTemporary.category}
            city={this.props.city}
            update={this.props.update.treeTemporary}
            type='temporary' />
        </div>
        <div className="text">
          {sankeyText}
        </div>
        <div className="graphic sankeygraphic">
					<Sankey
						width={Math.min(1680, Math.max(1070, renderWidth))}
						city={this.props.city}
						year={this.props.params.sankey.year}
						update={this.props.update.sankey}
					/>
				</div>
      </div>
    );
  }
}

export default ScaleMetropolitan;



// WEBPACK FOOTER //
// ./src/ScaleMetropolitan.jsx